import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import config from '../config';

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});
const RegularLayout = Loadable({
    loader: () => import('./layout/RegularLayout'),
    loading: Loader
});
class App extends Component {
    checkTimeout() {
        let setupTime = localStorage.getItem('setupTime');
        const now = new Date().getTime();
        const hours = (config.expiredTime) ? config.expiredTime : 24;
        const expiredTime = hours * 60 * 60 * 1000;
        if (setupTime == null) {
            localStorage.setItem('setupTime', now)
        } else {
            if (now - setupTime > expiredTime) {
                localStorage.clear()
                localStorage.setItem('setupTime', now);
            }
        }
    }
    render() {
        this.checkTimeout();
        const menu = routes.map((route, index) => {
            return (route.component) ? (
                <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                        <route.component {...props} />
                    )} />
            ) : (null);
        });
        const PrivateRoute = ({ component: Component, ...rest }) => (
            <Route {...rest} render={(props) => (
                localStorage.getItem('token')
                    ? (localStorage.getItem("isAdmin") === 'true') ? <AdminLayout {...props} /> : <Component {...props} />
                    : <Redirect to='/auth/login' />
            )} />
        )
        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader />}>
                        <Switch>
                            {menu}
                            <PrivateRoute path="/" component={RegularLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
